import {
  RenderSelectInput,
  RenderTextArea,
  RenderTextInput,
} from "app/common/renderInput";
import React from "react";
import { Button } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import CountryAutoComplete from "../CountryAutoComplete";
import CityAutoComplete from "../CityAutoComplete";
import HotelAutoComplete from "../HotelAutocomplete";

export default function HotelDetails({
  values,
  setFieldValue,
  handleChange,
  touched,
  handleBlur,
  errors,
  setIsManualEntry,
  isManualEntry,
}) {
  const ratingsOptions = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
    { value: 6, label: "6" },
    { value: 7, label: "7" },
    { value: 8, label: "8" },
    { value: 9, label: "9" },
    { value: 10, label: "10" },
  ];

  return (
    <div>
      {/* justify-content-end d-flex */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label style={{ fontWeight: "bold" }} className="mb-3">
            Country Name <span style={{ color: "red" }}>*</span>
          </label>
          <CountryAutoComplete setFieldValue={setFieldValue} />
        </div>
        <div className="col-md-3">
          <label style={{ fontWeight: "bold" }} className="mb-3">
            City Name <span style={{ color: "red" }}>*</span>
          </label>
          <CityAutoComplete setFieldValue={setFieldValue} values={values} />
        </div>
        {isManualEntry ? (
          <div className="col-md-4">
            <label style={{ fontWeight: "bold" }}>
              Hotel Name <span style={{ color: "red" }}>*</span>
            </label>

            <RenderTextInput
              type="text"
              // display={"Hotel Name"}
              className="form-control customInput"
              placeholder="Enter Hotel Name"
              name={`hotelName`}
              value={values?.hotelName || ""}
              onChange={handleChange}
              error={errors?.hotelName}
              touched={touched?.hotelName}
              onBlur={handleBlur}
              // required
            />
          </div>
        ) : (
          <div className="col-md-4">
            <label style={{ fontWeight: "bold" }} className="mb-3">
              Hotel Name <span style={{ color: "red" }}>*</span>
            </label>
            <HotelAutoComplete setFieldValue={setFieldValue} values={values} />
          </div>
        )}

        <div className="col-md-2 bg-red">
          <label style={{ fontWeight: "bold" }} className="mb-4"></label>
          <div className="justify-content-end d-flex mt-2">
            {isManualEntry ? (
              <>
                <Button
                  size="md"
                  variant="outline-secondary"
                  onClick={() => {
                    setIsManualEntry(!isManualEntry);
                  }}
                >
                  <RxCross2 />
                </Button>
              </>
            ) : (
              <Button
                size="md"
                variant="primary"
                onClick={() => {
                  setIsManualEntry(!isManualEntry);
                }}
              >
                Manual Entry
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-3">
          <label style={{ fontWeight: "bold" }}>
            Contact Number <span style={{ color: "red" }}>*</span>
          </label>
          <RenderTextInput
            type="text"
            name="cnt.ph"
            placeholder="Enter Hotel Contact Number"
            value={values?.cnt?.ph}
            touched={touched?.cnt?.ph}
            error={errors?.cnt?.ph}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        <div className="col-md-4 mb-3">
          <label style={{ fontWeight: "bold" }}>
            Postal Code / Pin Code /Area Code{" "}
            <span style={{ color: "red" }}>*</span>
          </label>
          <RenderTextInput
            type="text"
            name="address.postalCode"
            placeholder="Postal Code / Pin Code / Area Code"
            value={values?.address?.postalCode}
            touched={touched?.address?.postalCode}
            error={errors?.address?.postalCode}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>

        <div className="col-md-4 mb-3">
          <label style={{ fontWeight: "bold" }}>
            Ratings <span style={{ color: "red" }}>*</span>
          </label>
          <RenderSelectInput
            type="number"
            name="rating"
            value={values.rating}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.rating}
            touched={touched.rating}
            items={ratingsOptions}
          ></RenderSelectInput>
        </div>
        <div className="col mb-3">
          <label style={{ fontWeight: "bold" }}>
            Hotel Address <span style={{ color: "red" }}>*</span>
          </label>
          <RenderTextArea
            type="text"
            name="address.adr"
            placeholder="Hotel Address"
            value={values?.address?.adr}
            touched={touched?.address?.adr}
            error={errors?.address?.adr}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </div>
      </div>
    </div>
  );
}
